﻿require('./../scss/style.scss');

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./project/', true, /\.js$/));

import bulmaCollapsible from '@creativebulma/bulma-collapsible';

bulmaCollapsible.attach('.is-collapsible');
